import {
  computed,
  Directive,
  ElementRef,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  signal,
} from '@angular/core';
import { FoldState } from '../types/fold-state.type';

@Directive({
  selector: '[appDropdown]',
  standalone: true,
  host: {
    '[class]': 'dropdownClass',
    '(document:click)': 'foldIt($event)',
  },
})
export class Dropdown {
  elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  state: InputSignal<FoldState> = input.required<FoldState>();
  autoClose: InputSignal<boolean> = input<boolean>(false);
  stateChange: OutputEmitterRef<FoldState> = output<FoldState>();
  protected readonly isUnfold: Signal<boolean> = computed<boolean>(() => this.state() === 'unfold');

  protected readonly delay: Signal<number> = signal<number>(500);

  get dropdownClass(): string {
    return 'dropdown-directive-' + this.state();
  }

  foldIt(event: MouseEvent): void {
    const isTarget: boolean = this.elementRef.nativeElement.contains(event.target as HTMLElement);
    if (!isTarget && this.state() === 'unfold') {
      this.elementRef.nativeElement.classList.remove('dropdown-directive-unfold');
      this.elementRef.nativeElement.classList.add('dropdown-directive-fold');
      this.stateChange.emit('fold');
    }
  }
}
